import type { ReactElement } from 'react'
import React, { Children, isValidElement } from 'react'
import { twMerge } from 'tailwind-merge'

import Spacer from '@ui-kit/components/layoutComponents/Spacer/index.web'

import * as styles from './styles'
import type { WebProps } from './types'

const Stack = (props: WebProps): ReactElement => {
  const { space, ...divProps } = props
  const stackItems = Children.toArray(props.children)
    .filter(isValidElement)
    .map((child, index, children) => {
      return index !== Children.count(children) - 1
        ? [
            child,
            <Spacer size={space || styles.DEFAULT_SPACE} key={`spacer-${index.toString()}`} />,
          ]
        : child
    })

  return (
    <div
      {...divProps}
      className={twMerge('flex flex-col', divProps.className)}
      data-testid={props.id}
    >
      {stackItems}
    </div>
  )
}

export default Stack
